module.exports = __webpack_public_path__ + "static/media/feather.97ce2ccc.png";